export const cnConfig = {
  APP_LANDING: 'https://www.merrorai.cn',
} as const;
